/* TODO: t() */
import React, { Component } from 'react';
import { StyleProp, TextStyle } from 'react-native';

import formatCurrency from '../../core/support/formatCurrency';
import TextInput from './TextInput';

type Props = {
  accountCurrency: string;
  onChange?: (value: number) => void;
  defaultValue?: number;
  disabled?: boolean;
  allowNegative?: boolean;
  style?: StyleProp<TextStyle>;
};

type State = {
  value: string;
};

const decimalSeparator = (1.1).toLocaleString().charAt(1) ?? '.';

class CurrencyInput extends Component<Props, State> {
  static defaultProps = {
    defaultValue: 0,
  };

  state: State = {
    value: formatCurrency(
      this.props.defaultValue ?? 0,
      this.props.accountCurrency,
    ),
  };

  render() {
    let { value } = this.state;
    let { accountCurrency, defaultValue, disabled, style } = this.props;
    let defaultCurrency = formatCurrency(defaultValue ?? 0, accountCurrency);
    return (
      <TextInput
        disabled={disabled}
        invokeOnBlurBeforeSubmit
        placeholder={defaultCurrency}
        value={value}
        onBlur={this._onBlur}
        onChangeText={this._onChangeText}
        style={style}
      />
    );
  }

  _onBlur = () => {
    let { accountCurrency, onChange, allowNegative } = this.props;
    let number = parseInput(this.state.value);
    if (!allowNegative) {
      number = Math.max(0, number);
    }
    let currency = formatCurrency(number, accountCurrency);

    this.setState({ value: currency });

    onChange && onChange(number);
  };

  _onChangeText = (value: string) => {
    this.setState({
      value: value,
    });
  };
}

export function parseInput(input: string) {
  let isNegative = input.match(/^([^0-9-])?-/);
  let sanitized = input.split(decimalSeparator).map(toNumericDigits).join('.');
  let value = Math.round(Number(sanitized) * 100) || 0;
  return value * (isNegative ? -1 : 1);
}

function toNumericDigits(input: string) {
  return input.replace(/\D/g, '');
}

export default CurrencyInput;
